import { useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar"
import UserNavBar from "./UserNavBar"
import { UserSelect, User, FetchDeletedUsers } from "./UserSelect";
import { SelectInstance } from "react-select";

const RestoreUser = () => {
	interface Option {
		value: any;
		label: string;
	}
	
	
	var restoreRef = useRef<HTMLSelectElement>(null)
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	var [isUserSet, setIsUserSet] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })
	const [msg, setMsg] = useState("")

	useEffect(() => {
		FetchDeletedUsers(setUsers)
	},[setUsers])

	async function restoreUser() {
		const payload = {"id": selectedUser.id}
		const response = await fetch(process.env.REACT_APP_API+"/api/userRestore", {
			method: "POST",
			body: JSON.stringify(payload)
		})
		const result = await response.json()
		setMsg(selectedUser.first_name + " " + selectedUser.last_name + " restored.")
		setIsUserSet(false)
		isUserSet = false
		if (restoreRef && restoreRef.current) {
			restoreRef.current.value=""
		}
		if (selectRef && selectRef.current) {
			selectRef.current.setValue({ value: 0, label: "" }, "deselect-option")
		}
		FetchDeletedUsers(setUsers)
	}

	return (
		<div>
			<AdminNavBar />
			<UserNavBar />
			<h3>Restore User</h3>
			<UserSelect isVisible={isUserSet} setIsVisible={setIsUserSet} setUsers={setUsers} users={users} setSelectedUser={setSelectedUser} ref={restoreRef} onChange={setMsg} selectRef={selectRef} />
			{isUserSet &&
				<div className="resilire">
					<button onClick={restoreUser}>Restore</button>
				</div>
			}

			{msg && (
				<div>
					{msg}
				</div>
			)}
		</div>
	)
}

export default RestoreUser;
